import { createSelector } from 'reselect';

/**
 * Retorna tots els avisos del store
 * @param {} state
 * @return {Array}
 */
const totsAvisos = (state) => {
    //Si no tenim avisos que no retorni res.
    if (!state.avis.visualitzacio.avisos.tots) {
        return null;
    }

    return state.avis.visualitzacio.avisos.tots;
};

const idAvisSeleccionat = (state) => state.avis.visualitzacio.avisos.idAvisSeleccionat;

const buscarAvisSeleccionat = (tots, idAvisSeleccionat) => {
    if (!tots || !idAvisSeleccionat) {
        return null;
    }

    const detallAvis = tots.find((avis) => {
        return avis.id === idAvisSeleccionat;
    });

    return detallAvis || null;
};

const selector = createSelector(
    totsAvisos,      //Tots els avisos
    idAvisSeleccionat,
    buscarAvisSeleccionat
);

export default selector;


// WEBPACK FOOTER //
// ./src/selectors/selector_avis_per_id.js